import { Routes, Route, useLocation, Link, Navigate } from "react-router-dom";
import ProjectCode from "../ProjectCode/ProjectCode";
import CodeMatrix from "../CodeMatrix/CodeMatrix";
import ProjectSummary from "../ProjectCode/ProjectSummary";
import "./ProjectCodePage.css";

function ProjectCodePage() {
  // Folosim locația curentă ca să știm ce tab e activ și când afișăm summary
  const location = useLocation();

  // Stabilim simplu dacă suntem pe registry sau pe matrix
  const isRegistry = location.pathname.includes("/project_codes/project_codes");
  const isMatrix = location.pathname.includes("/project_codes/code_matrix");

  return (
    <div className="project-code-page">
      <div className="page-wrapper">
        {/* Header: titlul din stânga + summary în dreapta (doar pe registry) */}
        <div className="header-with-summary">
          <h2 className="title-pc">PROJECT CODE</h2>
          {isRegistry && <ProjectSummary />}
        </div>

        {/* Tabs: navigația între registry și matrix */}
        <nav className="tabs-pc" aria-label="Project code navigation">
          <Link
            to="/project_codes/project_codes"
            className={`tab-pc-button ${isRegistry ? "active" : ""}`}
          >
            Project Code Registry
          </Link>

          <Link
            to="/project_codes/code_matrix"
            className={`tab-pc-button ${isMatrix ? "active" : ""}`}
          >
            Code Matrix
          </Link>
        </nav>

        {/* Rutele interne */}
        <Routes>
          <Route index element={<Navigate to="project_codes" replace />} />
          <Route path="project_codes" element={<ProjectCode />} />
          <Route path="code_matrix" element={<CodeMatrix />} />
          <Route path="*" element={<Navigate to="project_codes" replace />} />
        </Routes>
      </div>
    </div>
  );
}

export default ProjectCodePage;